module.exports = __webpack_public_path__ + "img/icon-industry-over.86abc02d.svg";